import React from 'react';
import { ArrowUpRight } from 'lucide-react';

export const ServicesPage: React.FC = () => {
  const services = [
    {
      title: 'Individual Therapy',
      description: 'One-on-one counseling tailored to your unique needs and goals. We provide a safe, confidential space to explore challenges and develop coping strategies.',
      ageGroups: ['Adults (18+)', 'Adolescents (13-17)', 'Children (6-12)']
    },
    {
      title: 'Family & Couples Counseling',
      description: 'Strengthen relationships and improve communication. We help families and couples navigate conflicts and build healthier dynamics.',
      ageGroups: ['All Ages']
    },
    {
      title: 'Group Therapy',
      description: 'Connect with others facing similar challenges. Our therapeutic groups provide support, validation, and skill-building in a community setting.',
      ageGroups: ['Adults (18+)', 'Adolescents (13-17)']
    },
    {
      title: 'Substance Misuse Support',
      description: 'Compassionate treatment for substance use disorders, including court-mandated and voluntary programs.',
      ageGroups: ['Adults (18+)', 'Adolescents (13-17)']
    },
    {
      title: 'Telehealth Services',
      description: 'Access therapy from anywhere in the state. Our secure telehealth platform makes counseling convenient and accessible.',
      ageGroups: ['All Ages']
    },
  ];

  return (
    <div className="services-page">
      {/* Page Hero */}
      <section className="hero" style={{
        background: 'linear-gradient(135deg, rgba(239, 240, 241, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%)',
      }}>
        <div className="container-narrow text-center">
          <h1 className="text-5xl font-serif text-mscg-dark-gray mb-6">Our Services</h1>
          <p className="text-xl text-neutral-700">
            Explore Our Therapeutic Offerings
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="section bg-white">
        <div className="container">
          <div className="space-y-12">
            {services.map((service, idx) => (
              <div key={idx} className="card max-w-4xl mx-auto">
                <h3 className="text-3xl font-serif mb-4 text-mscg-dark-gray">{service.title}</h3>
                <p className="text-lg text-neutral-700 mb-6">{service.description}</p>
                <div>
                  <p className="font-semibold text-mscg-dark-gray mb-2">Age Groups Served:</p>
                  <div className="flex flex-wrap gap-2">
                    {service.ageGroups.map((age, i) => (
                      <span key={i} className="px-3 py-1 bg-mscg-light-gray text-mscg-dark-gray rounded-full text-sm">
                        {age}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section bg-mscg-light-gray">
        <div className="container-narrow text-center">
          <h2 className="text-4xl font-serif mb-6 text-mscg-dark-gray">Ready to Get Started?</h2>
          <p className="text-xl text-neutral-700 mb-8">
            Schedule a session with one of our compassionate therapists today.
          </p>
          <a href="#/contact" className="inline-flex items-center gap-3 bg-white text-black pl-8 pr-2 py-2 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl group">
            Schedule a Session
            <div className="w-10 h-10 rounded-full bg-[#d68800] text-white flex items-center justify-center transition-all duration-300 group-hover:bg-[#891719] group-hover:rotate-45">
              <ArrowUpRight className="w-5 h-5" />
            </div>
          </a>
        </div>
      </section>
    </div>
  );
};
